import { DownloadSimple } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useInvoicesMutations from "../../datahooks/useInvoicesMutations";

export default function DownloadInvoice({ invoiceId }: { invoiceId: string }) {
  const isDesktop = useTwBreakpoint("lg");
  const [invoiceUrl, setInvoiceUrl] = useState<string>();

  const { fetchInvoiceUrl, isFetchingInvoiceUrl } = useInvoicesMutations();

  function onClick() {
    fetchInvoiceUrl({ invoiceId }).then((url) => {
      setInvoiceUrl(url);
    });
  }

  return (
    <>
      <Button
        variant={isDesktop ? "secondary-black" : "outline-black"}
        size={isDesktop ? "sm" : "md"}
        intent={isDesktop ? "iconOnly" : "default"}
        leftIcon={!isDesktop && <DownloadSimple />}
        onClick={onClick}
        isLoading={isFetchingInvoiceUrl}
      >
        {isDesktop ? <DownloadSimple /> : "Download"}
      </Button>

      <Dialog
        open={!!invoiceUrl}
        onOpenChange={(open) => {
          if (!open) {
            setInvoiceUrl(undefined);
          }
        }}
      >
        <DialogContent>
          <DialogTitle>Your invoice is ready</DialogTitle>

          <DialogDescription className="mb-8">
            Click the button below to download your invoice
          </DialogDescription>

          <Button
            onClick={() => {
              window.open(invoiceUrl);
              setInvoiceUrl(null);
            }}
          >
            Download invoice
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
